import axios from "axios";
import firebaseWebConfig from "../firebaseWebConfig.json";

export const cancelToken = axios.CancelToken.source();

const createClient = () => {
	return axios.create({
		baseURL: `https://us-central1-${firebaseWebConfig.projectId}.cloudfunctions.net/api/`,
		headers: {
			Accept: "application/json",
			"Content-Type": "application/json",
		},
		//withCredentials: true
	});
};

export default createClient;
